export default __webpack_public_path__ + "static/ZoomIntegrations-b41eb7eb6a0453247d7c3bfd9ca5e624.webp";